<template>
    <intranet-nav-content>
        <template slot="links">
            <intranet-nav-content-link-exact :link="{ name: 'list', path: { name: 'admin-employees-list' } }"/>
            <intranet-nav-content-link :link="{ name: 'create', path: { name: 'admin-employees-create' } }"/>
        </template>
    </intranet-nav-content>
</template>

<script>
import IntranetNavContent from '@/layout/NavContent/IntranetNavContent';
import IntranetNavContentLink from '@/layout/NavContent/IntranetNavContentLink';
import IntranetNavContentLinkExact from '@/layout/NavContent/IntranetNavContentLinkExact';

export default {
    name: 'AdminEmployees',
    components: { 
        IntranetNavContent,
        IntranetNavContentLink,
        IntranetNavContentLinkExact
    },
};
</script>
